var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-pay" },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: _vm.$t("lang.pay.store"), "left-arrow": "" },
            on: { "click-left": _vm.goBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("div", { staticClass: "pay" }, [
            _c("div", { staticClass: "money-block" }, [
              _c("img", {
                staticClass: "moneys",
                attrs: { src: _vm.getMatchImg("coins"), alt: "" },
              }),
              _c("div", [_vm._v(_vm._s(_vm.amount))]),
              _vm.presentAmount > 0
                ? _c("i", [_vm._v("+" + _vm._s(_vm.presentAmount))])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "pay-other" },
              [
                _vm._l(_vm.presentPropList, function (item, index) {
                  return [
                    item.propType == 1
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("chat-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 2
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("video-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 4
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", { attrs: { src: _vm.getMatchImg("vip") } }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 6
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("call-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 9
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("coupon") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : item.propType == 15
                      ? _c("div", { staticClass: "dis-item" }, [
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("super-chat-pass") },
                          }),
                          _vm._v(" x" + _vm._s(item.number) + " "),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "select-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.wd.methodTit"))),
          ]),
          (_vm.scene != "activity" &&
            _vm.env.isIOS &&
            (_vm.compareVersion(_vm.appInfo.version, "1.1.0") === 1 ||
              _vm.compareVersion(_vm.appInfo.version, "1.1.0") === 0)) ||
          (_vm.scene != "activity" && !_vm.env.isIOS)
            ? _c("CouponEnter", {
                attrs: { maxCoupon: _vm.maxCoupon, styleType: "for-echo" },
                on: { openCouponPop: _vm.openCouponPop },
              })
            : _vm._e(),
          _vm._l(_vm.payList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "method-item",
                  _vm.loadingAn ? _vm.loadingAnimation : "",
                  _vm.disClassFn(item.desc, _vm.packageName),
                ],
                on: {
                  click: function ($event) {
                    return _vm.handleClickPay(item, index)
                  },
                },
              },
              [
                item.desc
                  ? _c("MyPLabel", {
                      staticClass: "discount",
                      attrs: {
                        str: item.desc,
                        customClass: { coin: "discount-coins" },
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "method-con",
                    class: { noClick: _vm.loadingShow },
                  },
                  [
                    _vm.showGoogle
                      ? [
                          _c("div", { staticClass: "method-img" }, [
                            _c("img", {
                              attrs: {
                                src: _vm._f("imgPath")(item.icon),
                                alt: "",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "line" }),
                          item.icon
                            ? _c("div", { staticClass: "method-name" }, [
                                _c("span", [_vm._v(_vm._s(item.name))]),
                                _c("div", { staticClass: "rate" }, [
                                  _c(
                                    "div",
                                    { staticClass: "pay-price" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            actTextColor:
                                              _vm.loadingShow &&
                                              item.name == _vm.selectPayName,
                                          },
                                        },
                                        [
                                          _c("i", [
                                            _vm._v(_vm._s(item.currency)),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.handleDiv100(item.price)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.loadingShow &&
                                      item.name == _vm.selectPayName
                                        ? _c("van-loading", {
                                            staticClass: "pay-loading",
                                            attrs: {
                                              type: "spinner",
                                              color: "#ffffff",
                                              size: "20px",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            )
          }),
          _vm.showGoogle && _vm.tip
            ? _c("div", { staticClass: "methods-tip" }, [
                _vm._v(" " + _vm._s(_vm.tip) + " "),
              ])
            : _vm._e(),
          _c("GooglePay", {
            attrs: {
              price: _vm.price,
              currency: _vm.currency,
              loadingShow: _vm.loadingShow,
            },
            on: { handleAppleAndGooglePay: _vm.handleAppleAndGooglePay },
          }),
        ],
        2
      ),
      _c("CouponPopup", {
        attrs: {
          active: _vm.popActive,
          showCouponPopup: _vm.showCoupon,
          tebTit: _vm.tebTit,
          maxCoupon: _vm.maxCoupon,
          validCouponListSort: _vm.validCouponListSort,
          expiredCouponList: _vm.expiredCouponList,
          styleType: "for-echo",
        },
        on: {
          close: _vm.closePop,
          confirmChooseCouponId: _vm.confirmChooseCouponId,
        },
      }),
      _c("PayResult", {
        attrs: {
          showDiaC: _vm.showResultDia,
          oneShow: true,
          title: _vm.payResultText,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }